import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { EllipsisContainer } from 'src/components/EllipsisContainer/EllipsisContainer';
import {
    MainContainer,
    MainEntityListItemText,
    MasterDetailsAsideItem,
} from 'src/components/MasterDetailsPage/MasterDetailsAsideItem';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { LegalEntity, Person } from 'src/generated-api-client';
import { BorrowerStatus } from 'src/pages/BorrowersPage/BorrowerStatus';
import { FullNameHelper } from 'src/utils/FullNameHelper';

type BorrowerListItemProps = { borrower: LegalEntity | Person };

export const BorrowerListItem = observer(
    ({ borrower }: BorrowerListItemProps) => {
        const fullName = FullNameHelper(borrower);

        return (
            <MasterDetailsAsideItem
                to={EntityLinks.borrowers.itemDetails(borrower.id)}
            >
                <MainContainer>
                    <Tooltip title={fullName}>
                        <EllipsisContainer>
                            <MainEntityListItemText data-testid="borrower-name">
                                {fullName}
                            </MainEntityListItemText>
                        </EllipsisContainer>
                    </Tooltip>
                    <BorrowerStatus borrower={borrower} />
                </MainContainer>
            </MasterDetailsAsideItem>
        );
    },
);
